export { default } from './FeedBadge'
